import { render, staticRenderFns } from "./ListKlasifikasi.vue?vue&type=template&id=4a4ca136"
import script from "./ListKlasifikasi.vue?vue&type=script&lang=js"
export * from "./ListKlasifikasi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports